import "../css/app.css";

import { createInertiaApp } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import QueryProvider from "./components/providers/query-provider";
import { TooltipProvider } from "./components/ui/tooltip";
import { initializeTheme } from "./hooks/use-appearance";

Sentry.init({
    dsn: "https://fa44628c3b8188de78fb38baf0bc4689@o4505113193218048.ingest.us.sentry.io/4510913382318080",
    sendDefaultPii: true,
});

createInertiaApp({
    title: (title) => (title ? `${title} - Mercadia` : "Mercadia"),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob("./pages/**/*.tsx")
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <QueryProvider>
                <TooltipProvider>
                    <App {...props} />
                    <Toaster richColors position="top-right" />
                </TooltipProvider>
            </QueryProvider>
        );
    },
    progress: {
        color: "#4B5563",
    },
});

initializeTheme();
